import basscanyon from '../assets/projects/basscanyon.jpg';
import rollingloud from '../assets/projects/rollingloud.jpg';
import sbau from '../assets/projects/sbau.png';
import lostlands from '../assets/projects/lostlands.jpg';
import caliroots from '../assets/projects/caliroots.jpg';
import everwild from '../assets/projects/everwild.jpg';
import eprincipal from '../assets/projects/eprincipal.png';
import reggae from '../assets/projects/reggae.jpg';
import findiss from '../assets/projects/findiss.png';
import listnerkids from '../assets/projects/listenerkids.png';
import s2o from '../assets/projects/s2o.jpg';
import holoholo from '../assets/projects/holoholo.jpg';
import hcff from '../assets/projects/hcff.jpg';
import wrestletalk from '../assets/projects/wrestletalk.png';
import entrenador from '../assets/projects/entrenador.jpg';
import singinglessons from '../assets/projects/singinglessons.png';
import bull from '../assets/projects/bull.png';
import gamefree from '../assets/projects/gamefree.png';

const images = {
  basscanyon,
  rollingloud,
  sbau,
  lostlands,
  caliroots,
  everwild,
  eprincipal,
  reggae,
  findiss,
  listnerkids,
  s2o,
  wrestletalk,
  holoholo,
  hcff,
  singinglessons,
  entrenador,
  bull,
  gamefree
};
export default images;
